import * as c from '../constants/simulation';
import { apiAction, gdlAction } from './api';
import {
  SIMULATION_GROUPING_DISTRICT,
  SIMULATION_GROUPING_GROUP,
  SIMULATION_GROUPING_CLASSROOM,
  SIMULATION_GROUPING_MINE,
  SIMULATION_GROUPING_TOP,
} from '../constants/simulation';
import { announce } from './announcements';

export const setSimulationView = (view) => ({
  type: c.SIMULATION_SET_VIEW,
  view,
});

export const setSimulationSort = (sortDir, sortField) => ({
  type: c.SIMULATION_SET_SORT,
  sortDir,
  sortField,
});

export const setSimulationSlot = (slot, designId, name) => ({
  type: c.SIMULATION_SET_SLOT,
  slot,
  designId,
  name,
});

export const setDesignGrouping = (grouping) => ({
  type: c.SIMULATION_SET_GROUPING,
  grouping,
});

export const setDesignFilter = (filter) => ({
  type: c.SIMULATION_SET_FILTER,
  filter,
});

export const setTopCount = (count) => ({
  type: c.SIMULATION_SET_TOP_COUNT,
  count,
});

export const loadContenders = () => (dispatch, getState) => {
  let filter;

  const { designGrouping } = getState().simulation;
  const { gameMode } = getState().app;

  switch (designGrouping) {
    case SIMULATION_GROUPING_DISTRICT:
      filter = 'district';
      break;
    case SIMULATION_GROUPING_GROUP:
      filter = 'group';
      break;
    case SIMULATION_GROUPING_CLASSROOM:
      filter = 'classroom';
      break;
    case SIMULATION_GROUPING_MINE:
      filter = 'mine';
      break;
  }

  dispatch(
    apiAction(
      [
        c.SIMULATION_LOAD_CONTENDERS,
        c.SIMULATION_LOAD_CONTENDERS_SUCCESS,
        c.SIMULATION_LOAD_CONTENDERS_FAILURE,
      ],
      (api) =>
        api.getContenderList({
          filter: filter,
        })
    )
  );
};

export const startSimulation = (skipUnity) => (dispatch, getState) => {
  const { startingCompetition, slot1, slot2 } = getState().simulation;

  if (startingCompetition) {
    return;
  }

  dispatch(
    gdlAction(
      [
        c.SIMULATION_START,
        c.SIMULATION_START_SUCCESS,
        c.SIMULATION_START_FAILURE,
      ],
      (api) => api.startSimulation(slot1.id, slot2.id, skipUnity)
    )
  ).then(() => {
    // Announce when competition animation starts
    dispatch(announce('Competition animation has started'));
  }).catch(() => {
    // Ignore errors, they're handled by the action
  });
};

export const finishSimulation = () => (dispatch) => {
  dispatch({
    type: c.SIMULATION_FINISH,
  });

  // Announce when competition ends and results are shown
  dispatch(announce('Competition has ended and results are shown'));

  dispatch(loadContenders());
};

export const resetSimulation = () => (dispatch) => {
  dispatch({
    type: c.SIMULATION_RESET,
  });

  // Announce when competition is reset
  dispatch(announce('Competition has been reset'));
};
